import React from 'react';

import { colors, darkThemeSelector, styled } from '../../stitches.config';
import { Box } from '../../utilities/Box/Box';

export type RuleProps = {
  height?: 1 | 2;
};

const InnerRule = styled(Box, {
  background: colors.strokeNeutralLight,
  [darkThemeSelector]: {
    background: colors.strokeNeutralDark,
  },
});
InnerRule.displayName = 'InnerRule';

export function Rule({ height = 1 }: RuleProps) {
  return (
    <Box padding={height === 1 ? { top: 1, bottom: 2 } : { y: 1 }} width="100%">
      <InnerRule width="full" height={height} />
    </Box>
  );
}
